const FileSlugToFileFieldMap = {
  proof_of_address: 'address_proof_file',
  sat_compliance_assessment: 'tax_compliance_certificate_file',
  tax_situation_certificate: 'tax_situation_file',
} as const

const FileSlugToFileNameMap = {
  proof_of_address: 'addressProof',
  sat_compliance_assessment: 'taxComplianceCertificate',
  tax_situation_certificate: 'taxSituation',
} as const

type FileSlug = keyof typeof FileSlugToFileFieldMap
type FileField = (typeof FileSlugToFileFieldMap)[FileSlug]
type FileName = (typeof FileSlugToFileNameMap)[FileSlug]

function isValidFileSlug(slug: string): slug is FileSlug {
  return slug in FileSlugToFileFieldMap
}

export function getFileFieldFromSlug(slug: string): FileField | undefined {
  return isValidFileSlug(slug) ? FileSlugToFileFieldMap[slug] : undefined
}

export function getFileNameFromSlug(slug: string): FileName | undefined {
  return isValidFileSlug(slug) ? FileSlugToFileNameMap[slug] : undefined
}
